import React, { ChangeEvent } from 'react';
import { FormSectionElements, ProgramContainer } from '../../entities/formTemplateDataType';
import { getRootComponent } from '../../utilities/ElementUtils';

type TransactionIdPorps = {
    appId: string;
    transactionId?: string;
    lang: 'en' | 'fr';
    field: FormSectionElements,
    callback: (programContainer: ProgramContainer) => void
};

const TransMessage = {
    en: 'Transaction ID',
    fr: 'ID de transaction',
}

const TransactionIdComponent = ({appId, transactionId, lang, field, callback}: TransactionIdPorps) => {

    const handleTansactionIdChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (field.ReadOnly) return;
        field.Value = e.target.value;
        const root = getRootComponent(field);
        callback(root);
    }

    return (
        <>
            {field.Visible && !field.ReadOnly &&(
                <div className='ontario-margin-top-24-! ontario-bottom-24-!' style={{maxWidth: '48rem'}}>
                    <label className="ontario-label" htmlFor={`${appId}-transaction-id-input`}>
                        {(lang==='en' ? field.ENUTitle : field.FRATitle) || TransMessage[lang]}
                        {field.Optional!=='Y' && <span className="ontario-label__flag">{lang==='en'? '(required)' : '(obligatoire)'}</span>}
                        {field.Optional==='Y' && <span className="ontario-label__flag">{lang==='en'? '(optional)' : '(facultatif)'}</span>}
                    </label>
                    <input 
                        className="ontario-input" 
                        type="text" 
                        id={`${appId}-transaction-id-input`} 
                        value={transactionId ?? ''} 
                        placeholder={TransMessage[lang]}
                        onChange={handleTansactionIdChange}
                    />
                </div>
            )}
            {field.Visible && field.ReadOnly &&(
                <div className='ontario-margin-top-24-! ontario-bottom-24-!' style={{display: 'flex', gap: '1rem', fontSize: '1.1rem'}}>
                    <span>{`${(lang==='en' ? field.ENUTitle : field.FRATitle) || TransMessage[lang]}${lang==='en'? ': ' : ' : '}`}</span>{transactionId ?? ''}
                </div>
            )}
        </>
    );
};

export default TransactionIdComponent;